<template>
  <img class="image" :src="imgSrc" />
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import type { MediaSchema } from '~/types/schema';
interface GraphicProps {
  media: MediaSchema;
  compressed?: boolean;
}
const props = defineProps({
  media: null,
  compressed: { type: Boolean, default: true }
});

const imgSrc = computed(() => {
  if (props.compressed && props.media.urlCompressed) {
    return props.media.urlCompressed;
  }
  return props.media.url;
});
</script>
<style lang="scss" scoped>
.image {
  display: block;
}
</style>
